
  import * as uploadcareRuntime$HChYoWadJRYDxt_45G7spULo__gp2twcKFAWvx7_45gh2ow from '/opt/build/repo/iznik-nuxt3/node_modules/@nuxt/image/dist/runtime/providers/uploadcare'
import * as weservRuntime$UtHGjc9GbNdTDBmxDlbXguwu99MCU_2vucDbXCx7mh0 from '/opt/build/repo/iznik-nuxt3/node_modules/@nuxt/image/dist/runtime/providers/weserv'
import * as netlifyRuntime$kuVKVMz7FnfjZtmLZYkoXPOhKhy1SmmGigy64_9mVHs from '/opt/build/repo/iznik-nuxt3/node_modules/@nuxt/image/dist/runtime/providers/netlifyImageCdn'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 576,
    "md": 768,
    "lg": 768,
    "xl": 768,
    "xxl": 768,
    "2xl": 768
  },
  "presets": {},
  "provider": "netlify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2,
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['uploadcare']: { provider: uploadcareRuntime$HChYoWadJRYDxt_45G7spULo__gp2twcKFAWvx7_45gh2ow, defaults: {"provider":"uploadcare"} },
  ['weserv']: { provider: weservRuntime$UtHGjc9GbNdTDBmxDlbXguwu99MCU_2vucDbXCx7mh0, defaults: {"provider":"weserv","baseURL":"https://uploads.ilovefreegle.org","weservURL":"https://delivery.ilovefreegle.org"} },
  ['netlify']: { provider: netlifyRuntime$kuVKVMz7FnfjZtmLZYkoXPOhKhy1SmmGigy64_9mVHs, defaults: {} }
    }
  }
